import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitTake'
})
export class SplitTakePipe implements PipeTransform {

  transform(value: string, splitChar: string, take: number = 0, limit: number = 9999): string {
    if (value && splitChar) {
      let splitParts = value.split(splitChar, limit);
      if (splitParts.length > take) {
        return splitParts[take];
      } else {
        return splitParts[splitParts.length - 1];
      }
    }

    return value;
  }

}
